export default "https://cdn-static.gokick.com/assets/3eb3f200054f2a6c9c5d0f37afa2d1dee3c44d6a/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";